import { FC } from 'react'
import * as Dropzone from 'react-dropzone'
import { styled } from '../../../config'
import { Box } from '../../Box'
import { ScrollbarBox } from '../../Box/ScrollbarBox'
import { OnRemove } from '../types'
import { FileItem } from './FileItem'

const Text = styled('div', {
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px'
})

const Container = styled(ScrollbarBox, {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  overflowY: 'auto'
})

interface Props {
  files: Dropzone.FileWithPath[]
  isDisabled?: boolean
  showFileCount?: boolean
  maxHeight?: string
  onRemove: OnRemove
  variant: 'default' | 'ai'
}

export const FileList: FC<Props> = ({ files, isDisabled, showFileCount, onRemove, variant, maxHeight }) => {
  return (
    <Box column>
      {showFileCount && files.length > 0 && (
        <Text css={{ paddingBottom: '12px' }}>Uploaded files: {files.length}</Text>
      )}
      <Container css={{ maxHeight }}>
      {files.map((file, index) => (
        <FileItem
          key={index}
          file={file}
          title={file.name}
          index={index}
          onRemove={onRemove}
          isDisabled={isDisabled}
          variant={variant}
        />
      ))}
      </Container>
    </Box>
  )
}
